<template>
  <div class="notifyDetail modelPage">
    <navbar :nav="nav"></navbar>
    <div class="contentText">
      <div class="title">{{ data.title }}</div>
      <div class="time">{{ data.createTime }}</div>
      <div class="desc" v-html="data.content">
        
      </div>
    </div>
  </div>
</template>

<script>
import navbar from "../../components/navbar/index.vue";
import { messageDetail } from "@/http/user";
export default {
  components: {
    navbar
  },
  data() {
    return {
      nav: {
        back: true,
        title: "",
        chat: false
      },
      data:{}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      messageDetail({ id: this.$route.query.id }).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.nav.title = data.title
          this.data = data
        }
      });
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style>
.notifyDetail.modelPage .contentText {
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  padding-top: 10px;
}
.notifyDetail .contentText .title,
.notifyDetail .contentText .time {
  text-align: center;
}
.notifyDetail .contentText .time {
  font-size: 14px;
  line-height: 18px;
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.45);
}
.notifyDetail .contentText .desc {
  margin-top: 18px;
  text-align: left;
  text-indent: 1rem;
}
.notifyDetail p {
  margin: 0;
  padding: 0;
  text-indent: 0;
}
.notifyDetail img{
  max-width: 100%;
}
@media screen and (min-width: 1439px) {
  .notifyDetail.modelPage .contentText {
    font-size: 16px; /* no*/
    line-height: 24px; /* no*/
    padding-top: 20px; /* no*/
  }
  .notifyDetail .contentText .time {
    font-size: 14px; /* no*/
    line-height: 18px; /* no*/
    margin-top: 8px; /* no*/
    color: rgba(0, 0, 0, 0.45); /* no*/
  }
  .notifyDetail .contentText .desc {
    margin-top: 18px; /* no*/
    text-indent: 1rem; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/model/notifyDetail.vue